var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96527 11.398L9.90006 14.3328L12.8349 11.398C13.144 11.0888 13.144 10.5875 12.8349 10.2784C12.5257 9.96917 12.0244 9.96917 11.7153 10.2784L9.90006 12.0936L8.08486 10.2784C7.77569 9.96917 7.27444 9.96917 6.96527 10.2784C6.65611 10.5875 6.65611 11.0888 6.96527 11.398Z",
    fill: "#BC2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96527 6.64794L9.90006 9.58274L12.8349 6.64794C13.144 6.33877 13.144 5.83752 12.8349 5.52835C12.5257 5.21919 12.0244 5.21919 11.7153 5.52835L9.90006 7.34356L8.08486 5.52835C7.77569 5.21919 7.27444 5.21919 6.96527 5.52835C6.65611 5.83752 6.65611 6.33877 6.96527 6.64794Z",
    fill: "#BC2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.c25672e7a49933848d793350b63983ae.svg";
export { ForwardRef as ReactComponent };